import { reactive } from 'vue'
import { deepCopy } from '@/util/deep-copy'

/*
 * 시트의 나머지 상태 — 구 V2ReservationManagementDataController 의 마지막 조각
 * (MDP-2295 ④-5 6단계).
 *
 * 앞선 단계들이 갱신 신호·필터·축·선택·팝업을 각자 가져가고 남은 것들이다. 서로 묶이는
 * 성격은 아니지만, 억지로 다른 모듈에 끼워 넣기보다 한 곳에 구역을 나눠 두는 편이
 * 어디를 봐야 하는지 분명하다.
 *
 * 이 단계가 끝나면 컨트롤러에는 알럿만 남는다(7단계).
 */

/*
 * 시트 격자의 기본 치수 — 바뀌지 않으므로 반응형에 넣지 않는다.
 * (구 컨트롤러는 model 에 담아 두었지만 아무도 쓰지 않는 값이었다)
 */
export const SHEET_METRICS = {
    defaultTopMargin: 61,
    defaultLeftMargin: 50,
    defaultCellHeight: 26,
    defaultCellWidth: 160,
} as const

type UserNote = Record<string, unknown>

export const sheetState = reactive({
    /*
     * 로딩 표시.
     * - isSheetLoading      시트 전체를 덮는다
     * - isPopupLoading      팝업 안에서만
     * - isSheetCellsLoading 칸 내용만 (골격은 그대로 두고)
     */
    isSheetLoading: false,
    isPopupLoading: false,
    isSheetCellsLoading: false,

    /** 보고 있는 날이 휴무일인가 — 맞으면 시트 전체가 안내 오버레이로 덮인다 */
    isHoliday: false,

    /** 병원의 예약 설정 문서 (운영시간·표시항목·색상 팔레트 등) */
    reservationSetting: undefined as Record<string, unknown> | undefined,

    /*
     * 시트의 DOM 참조.
     * 팝업·메뉴를 띄울 좌표와 스크롤 위치를 재는 데 쓴다 — 계산에 실제 크기가 필요해
     * 요소를 직접 들고 있다.
     */
    sheetElement: undefined as unknown,
    sheetScrollElement: undefined as unknown,

    /** 예약에 달린 고객 메모 목록 */
    reservationUserNotes: [] as UserNote[],
})

/** 배열이 아니면 빈 목록으로 둔다 — 구 setter 의 방어를 그대로 옮겼다 */
export function setReservationUserNotes(array: unknown): void {
    sheetState.reservationUserNotes = Array.isArray(array)
        ? ((deepCopy(array) ?? []) as UserNote[])
        : []
}
